import { render, staticRenderFns } from "./ds-columns.vue?vue&type=template&id=121e8812&scoped=true&"
import script from "./ds-columns.vue?vue&type=script&lang=ts&"
export * from "./ds-columns.vue?vue&type=script&lang=ts&"
import style0 from "./ds-columns.vue?vue&type=style&index=0&id=121e8812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e8812",
  null
  
)

export default component.exports